export default {
  title: 'Event Chat',
};
